/** Utah's words for basis.ts (telling a law line from advice by its citation). */
export const BASIS_UT = {
  /** Regex alternatives that mark a line as citing Utah law: R392 rules, Utah Code, Utah Admin. Code, the fire code R710. */
  lawCitePattern: String.raw`R392-\d|Utah Code|Utah Admin|R710-\d`,
} as const;
